// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAI, getGenerativeModel, GoogleAIBackend } from "firebase/ai";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBPHXPNOA2OI1ni4K7dZJUrU_6ePocUi0E",
  authDomain: "bakayise-website-builder.firebaseapp.com",
  projectId: "bakayise-website-builder",
  storageBucket: "bakayise-website-builder.firebasestorage.app",
  messagingSenderId: "452498662302",
  appId: "1:452498662302:web:13938ebc90efade8bfac8f",
  measurementId: "G-QCMG9TCRPM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// ✅ Local dev debug token (ONLY for development)
if (process.env.NODE_ENV === "development") {
  // This prints a debug token in the browser console the first time.
  // You then add that token in Firebase Console → App Check → Debug tokens.
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// ✅ App Check
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(
    process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY
  ),
  isTokenAutoRefreshEnabled: true,
});

// Initialize the Gemini Developer API backend service
export const ai = getAI(app, { backend: new GoogleAIBackend() });

// Create a `GenerativeModel` instance with a model that supports your use case
export const model = getGenerativeModel(ai, { model: "gemini-2.5-flash-lite" });